import { Component, HostListener, OnInit } from '@angular/core';
import { sideBar, sideBar2, SideBar2Const } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { dashboardNotification, UserResponse } from '../../models/auth.model';
import { UserRole } from '../../core/constants/keys.constant';
import { SocketService } from '../../services/socket.service';

@Component({
  selector: 'mindbase-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected assetsConst = assets;
  public sideBar = sideBar;
  public sideBar2 = sideBar2;
  protected profile: UserResponse | null = null;
  protected UserRole = UserRole;
  protected webLogo: any;
  protected SideBar2Const = SideBar2Const;
  public innerWidth = 0;
  public sidenavWidth = 5;
  public supportNotificationCount : number | undefined = 0;
  public chatNotificationCount: number | undefined = 0;
  public notificationCount: number | undefined = 0;
  constructor(public _authService: AuthService, private router: Router, private _socketService: SocketService) {
  }

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null) {
          this.profile = res;
        }
      });
    this.webLogo = this.getWebSettings()?.webLogo || '';
    this.getNotificationCount();
    this.getSupportCount();
    this.getChatCount();
    this.chatCountUpdated();
    this.noti_received();
    this.supportCountUpdated();
    this.clearNotifications();
  }

  getWebSettings(): any {
    const val = localStorage.getItem('webSettings');
    if (!val || val === 'undefined') return {};
    try {
      return JSON.parse(val);
    } catch {
      return {};
    }
  }

  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  isRouteActive(path: any): boolean {
    const currentUrl = this.router.url.split('?')[0]; // Remove query parameters from the URL

    // Exclude specific route from being marked as active
    if (path === '/manage-tutoring/tutor-package') {
      return false;
    }

    if (currentUrl === '/manage-counselling/all-counsellors' && path === '/manage-counselling/counsellors') {
      return true;
    }

    // Check if the current URL starts with the given path
    return currentUrl.startsWith(path);
  }

  protected clearNotifications(): void {
    this._authService.chatClicked.subscribe((res: any) => {
      if (res) {
        this.chatNotificationCount = 0;
      }
    });
    this._authService.notificationClicked.subscribe((res: any) => {
      if (res) {
        this.notificationCount = 0;
      }
    });
    this._authService.supportClicked.subscribe((res: any) => {
      if (res) {
        this.getSupportCount();
      }
    });
  }

  protected getNotificationCount(): void {
    this._authService
      .getNotificationCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.notificationCount = res.receiverNotificationCount;
        }
      });
  }

  protected getChatCount(): void {
    this._authService
      .getChatCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.chatNotificationCount = res.receiverChatCount;
        }
      });
  }

  protected getSupportCount(): void {
    this._authService
      .getSupportCount()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: dashboardNotification) => {
          this.supportNotificationCount = res.receiverSupportTicketCount.totalUnreadSupportTickets;
        }
      });
  }

  private chatCountUpdated(): void {
    this._socketService.onEvent('chatCountUpdated').subscribe({
      next: (res: any) => {
        this.chatNotificationCount = res.data;
      }
    });
  }

  private supportCountUpdated(): void {
    this._socketService.onEvent('SupportTicketCountUpdated').subscribe({
      next: (res: any) => {
        this.supportNotificationCount = res.data.totalUnreadSupportTickets;
      }
    });
  }

  private noti_received(): void {
    this._socketService.onEvent('noti_received').subscribe({
      next: (res: any) => {
        this.notificationCount = res.data;
      }
    });
  }

}

